module.exports = __webpack_public_path__ + "img/Vector.c0992aa6.svg";